import {
  queryOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { api, logout as clearTokens } from "../http";

export const userInfoQueryOptions = queryOptions({
  queryKey: ["auth", "me"],
  queryFn: () => api.auth.me().then((r) => r.json()),
});

/** Cache key for profile picture — updated via POST/DELETE on `/api/v1/auth/me/picture` only. */
export const profilePictureQueryKey = ["auth", "me", "picture"] as const;
export function useLogoutMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      // Call the logout endpoint on the server
      await api.auth.raw.post("api/v1/auth/logout");
      // Clear local tokens
      clearTokens();
    },
    onSuccess: () => {
      // Clear all cached queries
      queryClient.clear();
    },
  });
}
